// extracted by mini-css-extract-plugin
module.exports = {"title":"Map_title__TcWme","actionsWrapper":"Map_actionsWrapper__2xCrt","label":"Map_label__1v1KE"};